import api from "./api";

const root = document.documentElement; // Get the root element

// Function to get CSS variable value
export const getThemeVariable = (variable: string): string => {
  return getComputedStyle(root).getPropertyValue(variable).trim();
};

// Function to set CSS variable dynamically
export const setThemeVariable = (variable: string, value: string) => {
  root.style.setProperty(variable, value);
};

// Function to apply theme colors dynamically
export const applyTheme = (colors: {
  primary: string;
  secondary: string;
  tertiary: string;
}) => {
  setThemeVariable("--color-primary", colors.primary);
  setThemeVariable("--color-secondary", colors.secondary);
  setThemeVariable("--color-tertiary", colors.tertiary);
};

export const getCompanyTheme = async () => {
  const response = await api.get("/Branding/GetBranding");
  return response.data;
};

export const addCompanyTheme = async (themePayload: FormData) => {
  const response = await api.post(
    "/Branding/AddBranding",
    themePayload,
    {
      headers: {
        "Content-Type": "multipart/form-data", // Required for FormData
      },
    }
  );
  return response
};

export const updateCompanyTheme = async (finalPayload: FormData) => {
  const response = await api.put("/Branding/UpdateBranding", finalPayload, {
    headers: {
      "Content-Type": "multipart/form-data", // Required for FormData
    },
  });
  return response;
};

export const getPackages = async () => {
  const response = await api.get("/Stripe/GetPackages");
  return response.data;
};
